import { useSelector } from 'react-redux';
import { useEffect } from 'react';

import { getIsShortcutActionAllowed } from '../../../reducers/cafaConfigs';

export function useCollapseAllShortcut(setShow: (boolean) => void) {
  const collapseAllShortcutEnabled = useSelector(
    getIsShortcutActionAllowed('collapseAll'),
  );
  const expandAllShortcutEnabled = useSelector(
    getIsShortcutActionAllowed('expandAll'),
  );

  // Not using useShortcut because it only allows specifying the key
  // While i can check modifiers in the callback, it will still block
  // other useShortcuts on the same key even if i choose to do nothing
  // Therefore, until useShortcut supports specifying modifiers / filter conditions / returning false to skip,
  // It should not be used here so it doesn't block other plus/minus shortcuts
  useEffect(() => {
    const listener = e => {
      if (
        e.code === 'NumpadSubtract' &&
        e.ctrlKey &&
        e.shiftKey &&
        collapseAllShortcutEnabled
      ) {
        setShow(false);
      }
      if (
        e.code === 'NumpadAdd' &&
        e.ctrlKey &&
        e.shiftKey &&
        expandAllShortcutEnabled
      ) {
        setShow(true);
      }
    };
    document.addEventListener('keydown', listener);
    return () => document.removeEventListener('keydown', listener);
  }, [setShow, collapseAllShortcutEnabled, expandAllShortcutEnabled]);
}
